import {PageWrapper} from "../common/PageWrapper";
import BottomWidgetPreview from "./preview/BottomWidget";
import {DateRangePicker} from "@heroui/date-picker";
import {Input} from "@heroui/input";
import {Button} from "@heroui/button";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import dayjs from "dayjs";
import {initOffer, storeOffer, updateCurrentOffer} from "../../store/slices/beDirectSlice";
import {useEffect} from "react";
import {parseDate} from "@internationalized/date";
import {useParams} from "react-router";

export default function CreateOffer() {

    const { id } = useParams<{ id: string }>()

    const dispatch = useAppDispatch()

    const { currentHotel } = useAppSelector(state => state.hotels)

    const { currentOffer, fetching } = useAppSelector(state => state.beDirectSlice)

    useEffect(() => {
        if ((!currentOffer || (currentOffer.idBeDirectOffer?.toString() !== id)) && currentHotel) {
            dispatch(initOffer(currentHotel))
        }
    }, [ id, currentOffer, currentHotel ]);

    if (!currentOffer) return <>...</>

    return (
        <PageWrapper centered maxWidth={'1000px'}>

            <div className="text-3xl font-bold">
                Crea la tua campagna
            </div>

            <div className="mt-6 mb-6 flex flex-col space-y-7">
                <Input variant="bordered" label="Nome della campagna" type="text" value={currentOffer.title} onValueChange={val => {
                    dispatch(updateCurrentOffer({
                        ...currentOffer,
                        title: val
                    }))
                }} />

                <DateRangePicker
                    variant="bordered"
                    value={{
                        start: parseDate(currentOffer.startDate),
                        end: parseDate(currentOffer.endDate)
                    }}
                    className="max-w-xs"
                    label="Periodo di validità"
                    onChange={val => {
                        dispatch(updateCurrentOffer({
                            ...currentOffer,
                            startDate: dayjs(val?.start.toDate('Europe/Rome')).format('YYYY-MM-DD'),
                            endDate: dayjs(val?.end.toDate('Europe/Rome')).format('YYYY-MM-DD')
                        }))
                    }}
                />

                <div>
                    <div className="text-xl text-slate-700 pt-6 mb-4 font-bold">
                        Configura l'annuncio
                    </div>
                    <div className="text-slate-500">
                        configura più varianti per misurare le performance dei tuoi annunci sulla base dei contenuti. Effettueremo noi
                        la rotazione automatica in modalità A/B mostrando più spesso la variante con le migliori performance.
                    </div>
                </div>

                <BottomWidgetPreview directOffer={currentOffer} />
            </div>

            <Button color="primary" isLoading={fetching.createOffer} onPress={() => {
                console.log(currentOffer)
                if (currentOffer) {
                    dispatch(storeOffer({ offer: currentOffer }))
                }
            }}>Salva</Button>

        </PageWrapper>
    )

}
